<script>
    import {
        health, energy, hygiene, culture,
        iq, loneliness, confidence, stress,
        honesty, optimism, fitness
    } from './stores.js';
    import ItemsList from "./ItemsList.svelte";
    import {JobCategories} from "./jobs";
    import JobAdsList from "./JobAdsList.svelte";

    function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    let currentJobCategory = null;

    let enterCategory = (category) => {
        currentJobCategory = category;
    };

</script>

<style>
    * {
        font-family: TimesNewRoman;
        --sl-input-font-family: TimesNewRoman;
        color: #302d25;
    }
    div {
        align-items: center;
        height: 90vh;
        max-height: 100vh;
    }
    h1 {
        margin-top: 1em;
        font-size: 3rem;
        text-align: center;
    }
    categories {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: stretch;
    }
    sl-button {
        margin-bottom: 1em;
        margin-left: 0.4em;
    }
    #back {
        position: absolute;
        top: 1em;
        left: 1em;
    }
</style>

<div>
    {#if currentJobCategory === null}
        <h1>Job Ads</h1>
        <categories>
            {#each Object.values(JobCategories).filter(n => n>0) as category}
                <sl-button size="large" on:click={() => enterCategory(category)}>
                    {getKeyByValue(JobCategories, category)}
                </sl-button>
            {/each}
        </categories>
    {:else}
        <sl-button id="back" type="default" size="large" on:click={() => enterCategory(null)}>
            ⬅ Back
        </sl-button>
        <h1>{getKeyByValue(JobCategories, currentJobCategory)} Section</h1>
        <JobAdsList currentJobCategory={currentJobCategory} />
    {/if}
</div>
